import SettingContent from './SettingContent'

export default SettingContent
